<button matButton="outlined"
        [disabled]="!service.needsSave()"
        (click)="service.save()">Spara
</button>